// Deleting a row asks first (AC10). A modal rather than window.confirm, which blocks the page;
// the same <dialog> every other confirmation uses. A refusal stays in the dialog beside the
// control that was refused - closing it would leave the person wondering what happened.

import { useState } from 'react';

import { deleteDelivery } from '../api.js';
import Modal from '../ui/Modal.jsx';

export default function DeleteDialog({ leg, deliveryId, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await deleteDelivery(leg, deliveryId);
      onDeleted(deliveryId);
    } catch (err) {
      setError(
        err.status === 403 ? 'Only the person who added a row may delete it.' : err.message,
      );
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Delete {deliveryId}?</h3>
        <p className="hint">The row is removed from the tracker. This cannot be undone.</p>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" disabled={busy}>{busy ? 'Deleting…' : 'Delete'}</button>
        </menu>
      </form>
    </Modal>
  );
}
